import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Card, CardColors, Dialog, Image, Text } from '@/ui'
import {
  ONBOARDING_V2_ROUTE_NAMES,
  OnboardingTaskIdents,
} from '@/features/onboarding/config'
import { useAnalyticsTrack } from '@/features/amplitude'
import { UploadPrevMonthStatementStatus } from '@/features/user/dashboard/lib/userActionItemStatuses'
import { markUserActionItemCompleteIfExists } from '@/features/user/dashboard/lib/service'
import { TypographyStyles } from '@/styles'

export const SkipConnectBankAccountModal = ({
  closeModal,
}: {
  closeModal: () => void
}) => {
  const track = useAnalyticsTrack()
  const navigate = useNavigate()

  const handleSkipClick = useCallback(async () => {
    track('completed onboarding item connect financial accounts', {
      status: 'skipped',
    })
    await markUserActionItemCompleteIfExists(
      OnboardingTaskIdents.CONNECT_A_BUSINESS_BANK_ACCOUNT,
      track,
      UploadPrevMonthStatementStatus.skipped
    )
    navigate(ONBOARDING_V2_ROUTE_NAMES.ONBOARDING_COMPLETE)
  }, [track, navigate])

  const handleCloseModal = () => {
    track('cancelled skip connect business account')
    closeModal()
  }

  return (
    <Dialog open onOpenChange={handleCloseModal}>
      <Dialog.Content className="sm:max-w-md">
        <Dialog.Title>Are you sure you want to skip?</Dialog.Title>
        <Card color={CardColors.DANGER}>
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-shrink-0">
              <Image
                src="https://heard-images.s3.amazonaws.com/assets/warning-logo.png"
                alt="warning"
                className="w-20 h-20"
              />
            </div>
            <div className="flex flex-col justify-center">
              <Text variant={TypographyStyles.BODY_SM}>
                You need to connect a business checking account to use Heard.
              </Text>
              <Text variant={TypographyStyles.BODY_SM} className="mt-2">
                If you don&apos;t have a compatible account, you can skip for
                now and return later to connect it.
              </Text>
            </div>
          </div>
        </Card>
        <Dialog.Footer className="mt-6 flex justify-end gap-2">
          <Dialog.Close asChild>
            <Button variant="link">Go Back</Button>
          </Dialog.Close>
          <Button onClick={handleSkipClick} variant="danger">
            Skip
          </Button>
        </Dialog.Footer>
      </Dialog.Content>
    </Dialog>
  )
}
